const dashboard = {
  breadcrumb: "Dashboard",
  // Shared "Show more / Show less" toggle for sections with a card grid
  // capped to the first four (Client / Company Satisfaction).
  showMore: "Show more",
  showLess: "Show less",
  header: {
    welcomeBack: "Welcome back, {name}",
    welcomeBackNoName: "Welcome back",
    periodNote: "Data shown for the last 30 days",
    platformOverview: "Here's a platform-wide overview across all companies today.",
    createEvent: "Create Event",
  },
  refresh: {
    action: "Refresh data",
    refreshing: "updating…",
    justNow: "updated just now",
    minutesAgo: "updated {value} min ago",
    hoursAgo: "updated {value} hr ago",
  },
  stats: {
    delta: "{value} last 30 days",
    period: "Last 30 days",
    admin: {
      totalCompanies: "Total Companies",
      totalEvents: "Total Events",
      totalClients: "Total Clients",
      totalApplicants: "Total Applicants",
      totalWorkingHours: "Total Working Hours",
      hoursUnit: "{value} Hr",
      // Tooltip of the info icon beside a KPI label — what the number counts.
      info: {
        totalEvents: "Upcoming + ongoing + completed events",
        totalWorkingHours: "Completed and ongoing events",
      },
      empty: {
        totalCompanies: "No companies yet",
        totalEvents: "No events yet",
        totalClients: "No Clients yet",
        totalApplicants: "No applicants yet",
        totalWorkingHours: "No shifts logged",
      },
    },
    company: {
      totalEvents: "Total No. of Events",
      loyalApplicants: "Loyal Applicants",
      saudiApplicants: "Saudi Applicants",
      saudiApplicantsNote: "(Completed Events)",
      pendingApplicantsRequest: "Pending Applicants Request",
      applicantsUnder5Events: "Applicants < 5 Events",
      applicantsUnder5EventsNote: "(ongoing event)",
      empty: {
        totalEvents: "No events yet",
        loyalApplicants: "None yet",
        saudiApplicants: "No completed events yet",
        pendingApplicantsRequest: "All caught up",
        applicantsUnder5Events: "No applicants yet",
      },
    },
  },
  platformStats: {
    activeCompanies: {
      label: "Active Companies",
      empty: "No companies yet",
    },
    activeEvents: {
      label: "Ongoing Events",
      empty: "No events yet",
    },
    workingApplicants: {
      label: "Yoram Applicants",
      empty: "No applicants yet",
      joinedEvents: "Joined Events",
      availableToJoin: "Not joined",
      saudiTag: "Saudi",
    },
    attendanceRate: {
      label: "Overall Attendance Rate",
      info: "Ongoing events only",
      empty: "No attendance data yet",
    },
    lateAndNoShow: {
      label: "Late & No-Show",
      info: "Ongoing events only",
      empty: "None recorded",
    },
  },
  topEventsByActivity: "Top Events by Activity",
  topEvents: {
    title: "Top Events by Activity",
    viewEvents: "View Events",
    columns: {
      rank: "#",
      event: "Event",
      applicants: "Applicants",
      status: "Status",
    },
    // Status labels come from shared.eventStatusOptions (see the Total Events
    // section below).
    empty: {
      title: "No events yet",
      description:
        "Once you create an event, it'll show up here ranked by applicant activity.",
    },
  },
  topEventsByApplicants: {
    title: "Top Events by No. of Applicants",
    viewEvents: "View Events",
    columns: {
      rank: "#",
      event: "Event",
      companies: "Companies",
      applicants: "Applicants",
      status: "Status",
    },
    activeSince: "Active since {value}",
    empty: {
      title: "No events on the platform yet",
      description:
        "Once a company creates an event, it'll show up here ranked by applicant volume.",
    },
  },
  platformEvents: {
    title: "Total Events",
    empty: {
      title: "No event data yet",
      description:
        "Platform wide status breakdown will appear here once events exist.",
    },
  },
  topCompaniesBySaudiApplicants: {
    title: "Top Companies by No. of Saudi Applicants",
    viewCompanies: "View Companies",
    columns: {
      rank: "#",
      company: "Company",
      events: "Events",
      saudiApplicants: "Saudi Applicants",
    },
    activeSince: "Active since {value}",
    empty: {
      title: "No company activity yet",
      description:
        "Once companies start running events, the busiest ones will rank here.",
    },
  },
  companiesByStatus: {
    title: "Companies by Status",
    totalLabel: "Total companies",
    status: {
      approved: "Active",
      pending: "Pending",
      deactivated: "Deactivated",
    },
    empty: {
      title: "No companies registered yet",
      description:
        "Active vs pending status will show up here once companies join the platform.",
      action: "View Registration Requests",
    },
  },
  totalEvents: {
    title: "Events",
    totalLabel: "Total events",
    // Status labels come from shared.eventStatusOptions — same wording as
    // the Events list page's own tabs, one place to change it everywhere.
    empty: {
      title: "No events to break down yet",
      description:
        "Your events' status breakdown will appear here once you create an event.",
    },
  },
  ongoingEvents: {
    title: "Ongoing Events data",
    viewEvents: "View Events",
    showMore: "Show more",
    showLess: "Show less",
    newApplicants: "< 5 events",
    paymentPeriod: {
      daily: "Daily",
      monthly: "Monthly",
    },
    metrics: {
      attendanceRate: "Attendance Rate",
      checkIn: "Check-in",
      lateCheckIn: "Late Check-in",
      checkOut: "Check-Out",
      noShow: "No-Show",
    },
    nationality: {
      label: "Nationality Mix",
      applicantsLabel: "{count} applicants",
      saudi: "Saudi",
      nonSaudi: "Non-Saudi",
    },
    footer: {
      viewTimesheet: "View Timesheet",
      viewReports: "View Reports",
      openReports: "{count} Open Reports",
      noReports: "Open Reports: None open right now",
    },
    empty: {
      title: "No ongoing events right now",
      description: "Once an event is running, its attendance data will show up here.",
    },
  },
  satisfaction: {
    title: "Client Satisfaction",
    overall: "Overall Satisfaction",
    eventsEvaluated: "{count} events evaluated",
    eventsEvaluatedOne: "1 event evaluated",
    basedOn: "Based on {count} events",
    basedOnOne: "Based on 1 event",
    bands: {
      good: "Good",
      needAttention: "Need attention",
      low: "Low",
    },
    empty: {
      title: "No evaluations yet",
      description: "No completed evaluation rounds yet.",
    },
  },
  quickActions: {
    title: "Quick actions",
    viewRequests: "View Requests",
    types: {
      registration: {
        label: "Registration Requests",
        description: "New companies awaiting approval",
      },
      profileEdit: {
        label: "Profile Edit Requests",
        description: "Pending approval or rejection",
      },
      demo: {
        label: "Demo Requests",
        description: "Company admins awaiting decision",
      },
    },
    empty: {
      title: "You're all caught up",
      description:
        "No registration, profile edit, or demo requests are waiting on you right now.",
    },
  },
  applicantEngagement: {
    title: "Applicant Engagement",
    description:
      "Percentage of each company's applicants who have worked fewer than 5 events.",
    viewAllCompanies: "View all companies",
    empty: {
      title: "No applicant data yet",
      description:
        "This breakdown will show up once companies have applicants working events.",
    },
  },
  companySatisfaction: {
    title: "Company Satisfaction",
    clients: "{count} clients",
    clientsOne: "1 client",
    events: "{count} events evaluated",
    eventsOne: "1 event evaluated",
    bands: {
      good: "Good",
      needAttention: "Needs attention",
      low: "Low",
    },
    viewAllCompanies: "View all companies",
    empty: {
      title: "No client evaluations across the platform",
      description:
        "Once clients evaluate a company's events, satisfaction scores will roll up here per company.",
    },
  },
  recentActivity: {
    title: "Recent Activity Log",
    fullLogs: "Full Logs",
    modules: {
      companies: "Companies",
      companyAccount: "Company Account",
      teamPermissions: "Team & Permissions",
      clients: "Clients",
      events: "Events",
      joiningRequests: "Joining Requests",
      timesheet: "Timesheet",
      payroll: "Payroll",
      evaluations: "Evaluations",
    },
    empty: {
      title: "No activity yet",
      description:
        "Actions taken across companies, events, and requests will appear here as they happen.",
    },
  },
};
export default dashboard;
